import IDimensions from "../model/IDimensions";
import sessionStorageService from "./sessionStorageService";

function buildId(dimensions: IDimensions): string {
  return `${dimensions.country}_${dimensions.brand}_finance_form_input`;
}

export const financeFormInputStorage = {
  get: (dimensions: IDimensions) => {
    const isInSalesEnablement = JSON.parse(
      sessionStorageService.get("se_config_financeFormInput") || "false"
    );
    const storage = isInSalesEnablement ? sessionStorage : localStorage;
    const data = storage.getItem(buildId(dimensions));

    return data ? JSON.parse(data) : null;
  },

  save: (dimensions: IDimensions, data: any) => {
    const isInSalesEnablement = JSON.parse(
      sessionStorageService.get("se_config_financeFormInput") || "false"
    );
    const storage = isInSalesEnablement ? sessionStorage : localStorage;

    storage.setItem(buildId(dimensions), JSON.stringify(data));
  },
};
